<template>
  <TooltipTrigger :ref="forwardRef" as-child>
    <slot></slot>
  </TooltipTrigger>
</template>

<script setup lang="ts">
import { TooltipTrigger, useForwardExpose } from "reka-ui";

const { forwardRef } = useForwardExpose();
</script>
